import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import gameService from "../services/gameService";
import categoryService from "../services/categoryService";
import providerService from "../services/providerService";
import { getProjectNames } from "../services/projectService";
import projectImageService from "../services/projectImageService";
import fileUpload from "../utils/fileUpload";
import fileDelete from "../utils/fileDelete";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./GamesPage.css";

const GamesPage = () => {
  const [games, setGames] = useState([]);
  const [categories, setCategories] = useState([]);
  const [providers, setProviders] = useState([]);
  const [filteredProviders, setFilteredProviders] = useState([]);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [provider, setProvider] = useState("");
  const [releaseDate, setReleaseDate] = useState("");
  const [gameUuid, setGameUuid] = useState("");
  const [image, setImage] = useState(null);
  
  const [projectNames, setProjectNames] = useState([]);
  
  
  const [selectedProjectForGame, setSelectedProjectForGame] = useState("");
  const [gameProjectImageFile, setGameProjectImageFile] = useState(null);
  
  const [gameProjectImages, setGameProjectImages] = useState([]); // all images for current game
  const [editingGame, setEditingGame] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // ফিল্টার স্টেট
  const [filterName, setFilterName] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [filterProvider, setFilterProvider] = useState("");
  const [filterReleaseDateFrom, setFilterReleaseDateFrom] = useState("");
  const [filterReleaseDateTo, setFilterReleaseDateTo] = useState("");
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  useEffect(() => {
    const apiKey = localStorage.getItem("apiKey");
    const token = localStorage.getItem("token");
    if (!token || !apiKey) {
      toast.error("দয়া করে প্রথমে লগইন করুন এবং API কী সেট করুন", {
        position: "top-right",
      });
      navigate("/login");
      return;
    }
    loadCategories();
    loadProviders();
  }, [navigate]);

  useEffect(() => {
    if (categories.length > 0 && !category) {
      setCategory(categories[0]._id); // ফর্মের জন্য ডিফল্ট ক্যাটাগরি
    }
  }, [categories, category]);

  useEffect(() => {
    if (filteredProviders.length > 0 && !provider) {
      setProvider(filteredProviders[0]._id); // ফর্মের জন্য ডিফল্ট প্রোভাইডার
    }
  }, [filteredProviders, provider]);

  useEffect(() => {
    if (category) {
      const filtered = providers.filter(
        (prov) => prov.parentcategory?._id === category
      );
      setFilteredProviders(filtered);
      setProvider(""); // ক্যাটাগরি পরিবর্তন হলে প্রোভাইডার রিসেট
    } else {
      setFilteredProviders(providers);
    }
  }, [category, providers]);

  useEffect(() => {
    if (filterCategory) {
      const filtered = providers.filter(
        (prov) => prov.parentcategory?._id === filterCategory
      );
      setFilteredProviders(filtered);
      setFilterProvider(""); // ফিল্টার ক্যাটাগরি পরিবর্তন হলে ফিল্টার প্রোভাইডার রিসেট
    } else {
      setFilteredProviders(providers);
    }
  }, [filterCategory, providers]);

  // Load project names & project images
  useEffect(() => {
    const loadProjectData = async () => {
      try {
        const pnRes = await getProjectNames();
        setProjectNames(Array.isArray(pnRes.data.data) ? pnRes.data.data : []);
        // project-level images list removed from UI to avoid duplication
      } catch (err) {
        // silent
      }
    };
    loadProjectData();
  }, []);

  

  const loadGameProjectImage = async (gameId) => {
    try {
      const res = await projectImageService.getProjectImagesByGame(gameId);
      const list = Array.isArray(res.data.data) ? res.data.data : [];
      setGameProjectImages(list);
      const first = list[0] || null;
      setSelectedProjectForGame(first?.projectName?._id || "");
    } catch (err) {
      setGameProjectImages([]);
      setSelectedProjectForGame("");
    }
  };

  

  

  const loadCategories = async () => {
    try {
      const response = await categoryService.getCategories();
      setCategories(
        Array.isArray(response.data.data) ? response.data.data : []
      );
    } catch (error) {
      toast.error(
        "ক্যাটাগরি লোড করতে সমস্যা: " +
          (error.response?.data?.error || error.message),
        {
          position: "top-right",
        }
      );
    }
  };

  const loadProviders = async () => {
    try {
      const response = await providerService.getProviders();
      setProviders(Array.isArray(response.data.data) ? response.data.data : []);
      setFilteredProviders(
        Array.isArray(response.data.data) ? response.data.data : []
      );
    } catch (error) {
      toast.error(
        "প্রোভাইডার লোড করতে সমস্যা: " +
          (error.response?.data?.error || error.message),
        {
          position: "top-right",
        }
      );
    }
  };

  const loadGames = React.useCallback(async (filters = {}) => {
    setLoading(true);
    try {
      const response = await gameService.getGamesByPagination({
        ...filters,
        page,
        limit: 50,
      });

      setGames(Array.isArray(response.data.data) ? response.data.data : []);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      toast.error(
        "গেম লোড করতে সমস্যা: " +
          (error.response?.data?.error || error.message),
        {
          position: "top-right",
        }
      );
    } finally {
      setLoading(false);
    }
  }, [page]);

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setPage(1); // ফিল্টার প্রয়োগ করলে পেজ ১-এ রিসেট
    const filters = {
      name: filterName,
      category: filterCategory,
      provider: filterProvider,
      releaseDateFrom: filterReleaseDateFrom,
      releaseDateTo: filterReleaseDateTo,
    };
    loadGames(filters);
  };

  useEffect(() => {
    loadGames(); // কম্পোনেন্ট লোড হওয়ার সময় গেমগুলি লোড করুন
  }, [loadGames]);

  const handleCreate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let imageUrl = editingGame ? editingGame.image : "";
      if (image) {
        imageUrl = await fileUpload(image);
      }
      const gameData = {
        name,
        provider,
        category,
        releaseDate,
        game_uuid: gameUuid,
        image: imageUrl,
      };

      if (editingGame) {
        await gameService.updateGame(
          editingGame._id,
          gameData
        );
        toast.success("গেম সফলভাবে আপডেট হয়েছে!", { position: "top-right" });
        if (selectedProjectForGame && gameProjectImageFile) {
          const path = await fileUpload(gameProjectImageFile);
          await projectImageService.upsertProjectImage({
            projectName: selectedProjectForGame,
            image: path,
            gameId: editingGame._id,
          });
          toast.success("প্রজেক্ট ইমেজও আপডেট হয়েছে", { position: "top-right" });
        }
      } else {
        const created = await gameService.createGame(gameData);
        const newGameId = created?.data?.data?._id;
        toast.success("গেম সফলভাবে তৈরি হয়েছে!", { position: "top-right" });
        if (newGameId && selectedProjectForGame && gameProjectImageFile) {
          const path = await fileUpload(gameProjectImageFile);
          await projectImageService.upsertProjectImage({
            projectName: selectedProjectForGame,
            image: path,
            gameId: newGameId,
          });
          toast.success("প্রজেক্ট ইমেজও সংরক্ষিত", { position: "top-right" });
        }
      }
      resetForm();
      loadGames();
    } catch (error) {
      toast.error(
        `${editingGame ? "আপডেট" : "তৈরি"} ত্রুটি: ` +
          (error.response?.data?.error || error.message),
        { position: "top-right" }
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (game) => {
    setName(game.name);
    setCategory(game.category?._id || "");
    setProvider(game.provider?._id || "");
    setGameUuid(game.game_uuid || "");
    setReleaseDate(
      game.releaseDate
        ? new Date(game.releaseDate).toISOString().split("T")[0]
        : ""
    );
    setImage(null);
    setEditingGame(game);
    loadGameProjectImage(game._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm("আপনি কি এই গেমটি মুছে ফেলতে চান?")) {
      setLoading(true);
      try {
        const game = games.find((g) => g._id === id);
        if (!game) {
          throw new Error("গেম পাওয়া যায়নি।");
        }
        if (game.image) {
          await fileDelete(game.image);
        }
        await gameService.deleteGame(id);
        toast.success("গেম সফলভাবে মুছে ফেলা হয়েছে!", {
          position: "top-right",
        });
        loadGames();
      } catch (error) {
        toast.error(
          "মুছে ফেলার ত্রুটি: " +
            (error.response?.data?.error || error.message),
          {
            position: "top-right",
          }
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const resetForm = () => {
    setName("");
    setCategory(categories[0]?._id || "");
    setProvider(filteredProviders[0]?._id || "");
    setReleaseDate("");
    setGameUuid("");
    setImage(null);
    setEditingGame(null);
    setSelectedProjectForGame("");
    setGameProjectImageFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const resetFilters = () => {
    setFilterName("");
    setFilterCategory("");
    setFilterProvider("");
    setFilterReleaseDateFrom("");
    setFilterReleaseDateTo("");
    setPage(1);
    loadGames(); // রিসেট করার পর ডিফল্ট গেম লোড
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      const filters = {
        name: filterName,
        category: filterCategory,
        provider: filterProvider,
        releaseDateFrom: filterReleaseDateFrom,
        releaseDateTo: filterReleaseDateTo,
      };
      loadGames(filters);
    }
  };

  return (
    <div>
      <Header />
      <div className="game-dashboard">
        <ToastContainer />
        <div className="container py-5">
          <div className="row g-4">
            <div className="col-lg-12">
              <div className="card shadow-lg p-4 gradient-bg">
                <h2 className="text-center mb-4 text-white">
                  {editingGame ? "গেম আপডেট" : "নতুন গেম তৈরি"}
                </h2>
                <form onSubmit={handleCreate}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label text-white">
                      গেমের নাম
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-pill"
                      id="name"
                      placeholder="গেমের নাম লিখুন"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="gameUuid" className="form-label text-white">
                      গেম UUID
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-pill"
                      id="gameUuid"
                      placeholder="ইউনিক গেম UUID লিখুন"
                      value={gameUuid}
                      onChange={(e) => setGameUuid(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="category" className="form-label text-white">
                      ক্যাটাগরি
                    </label>
                    <select
                      id="category"
                      className="form-control rounded-pill"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      required
                      disabled={loading}
                    >
                      <option value="" disabled>
                        ক্যাটাগরি নির্বাচন করুন
                      </option>
                      {categories.map((cat) => (
                        <option key={cat._id} value={cat._id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="provider" className="form-label text-white">
                      প্রোভাইডার
                    </label>
                    <select
                      id="provider"
                      className="form-control rounded-pill"
                      value={provider}
                      onChange={(e) => setProvider(e.target.value)}
                      required
                      disabled={loading || !category}
                    >
                      <option value="" disabled>
                        প্রোভাইডার নির্বাচন করুন
                      </option>
                      {filteredProviders.map((prov) => (
                        <option key={prov._id} value={prov._id}>
                          {prov.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor="releaseDate"
                      className="form-label text-white"
                    >
                      রিলিজ ডেট
                    </label>
                    <input
                      type="date"
                      className="form-control rounded-pill"
                      id="releaseDate"
                      value={releaseDate}
                      onChange={(e) => setReleaseDate(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="image" className="form-label text-white">
                      ইমেজ নির্বাচন করুন
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="image"
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={(e) => setImage(e.target.files[0])}
                      disabled={loading}
                    />
                    {editingGame && editingGame.image && (
                      <div className="mt-2">
                        <p className="text-white">বর্তমান ইমেজ:</p>
                        <img
                          src={`${process.env.REACT_APP_API_URL}/${editingGame.image}`}
                          alt="Current game"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      type="submit"
                      className="btn btn-register rounded-pill px-4"
                      disabled={loading}
                    >
                      {editingGame ? <FaEdit /> : <FaPlus />}
                      {editingGame ? " আপডেট" : " তৈরি"}
                    </button>
                    {editingGame && (
                      <button
                        type="button"
                        className="btn btn-cancel rounded-pill px-4"
                        onClick={resetForm}
                        disabled={loading}
                      >
                        বাতিল
                      </button>
                    )}
                  </div>
                </form>
                {/* Project image attach section for both create and edit */}
                <div className="mt-4">
                    <div className="card shadow-sm">
                      <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">{editingGame ? "এই গেমের প্রজেক্ট ইমেজ" : "নতুন গেমের প্রজেক্ট ইমেজ (ঐচ্ছিক)"}</h5>
                        <small className="text-muted">একাধিক ইমেজ যোগ করতে পারেন</small>
                      </div>
                      <div className="card-body">
                        <div className="row g-3 align-items-end">
                          <div className="col-md-4">
                            <label className="form-label">প্রজেক্ট নির্বাচন করুন</label>
                            <select
                              className="form-control rounded-pill"
                              value={selectedProjectForGame}
                              onChange={(e) => setSelectedProjectForGame(e.target.value)}
                            >
                              <option value="">নির্বাচন করুন</option>
                              {projectNames.map((pn) => (
                                <option key={pn._id} value={pn._id}>{pn.title}</option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-5">
                            <label className="form-label">ইমেজ আপলোড</label>
                            <input
                              type="file"
                              accept="image/*"
                              className="form-control"
                              onChange={(e) => setGameProjectImageFile(e.target.files[0])}
                            />
                          </div>
                          <div className="col-md-3">
                            <button
                              type="button"
                              className="btn btn-register w-100 rounded-pill"
                            disabled={loading || (!editingGame && true) || !selectedProjectForGame || !gameProjectImageFile}
                              onClick={async () => {
                                try {
                                if (!editingGame) {
                                  toast.info("প্রথমে গেম তৈরি/আপডেট করুন", { position: "top-right" });
                                  return;
                                }
                                const path = await fileUpload(gameProjectImageFile);
                                await projectImageService.upsertProjectImage({ projectName: selectedProjectForGame, image: path, gameId: editingGame._id });
                                toast.success("প্রজেক্ট ইমেজ সংরক্ষিত", { position: "top-right" });
                                setGameProjectImageFile(null);
                                loadGameProjectImage(editingGame._id);
                                } catch (err) {
                                  toast.error("সংরক্ষণ ব্যর্থ", { position: "top-right" });
                                }
                              }}
                            >
                              ইমেজ যোগ করুন
                            </button>
                          </div>
                        </div>
                      {editingGame && (
                        <>
                          <hr />
                          <div>
                            <h6 className="mb-3">বর্তমান ইমেজসমূহ</h6>
                            {gameProjectImages.length === 0 ? (
                              <div className="text-muted">কোনো ইমেজ নেই</div>
                            ) : (
                              <div className="row g-3">
                                {gameProjectImages.map((img) => (
                                  <div key={img._id} className="col-sm-6 col-md-4 col-lg-3">
                                    <div className="border rounded p-2 h-100 d-flex flex-column">
                                      <img
                                        src={`${process.env.REACT_APP_API_URL}/${img.image}`}
                                        alt={img.projectName?.title || "Project"}
                                        style={{ width: "100%", height: "120px", objectFit: "cover" }}
                                        className="mb-2"
                                      />
                                      <div className="small text-muted mb-2">{img.projectName?.title || "Unnamed Project"}</div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </>
                      )}
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-4">
              <div className="card shadow-lg p-4">
                <h2 className="text-center mb-4 gradient-text">গেম তালিকা</h2>
                {/* ফিল্টার ফর্ম */}
                <div className="mb-4">
                  <h4 className="mb-3">গেম ফিল্টার</h4>
                  <form onSubmit={handleFilterSubmit}>
                    <div className="row g-3">
                      <div className="col-md-2">
                        <select
                          className="form-control rounded-pill"
                          value={filterCategory}
                          onChange={(e) => setFilterCategory(e.target.value)}
                          disabled={loading}
                        >
                          <option value="">সব ক্যাটাগরি</option>
                          {categories.map((cat) => (
                            <option key={cat._id} value={cat._id}>
                              {cat.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <select
                          className="form-control rounded-pill"
                          value={filterProvider}
                          onChange={(e) => setFilterProvider(e.target.value)}
                          disabled={loading}
                        >
                          <option value="">সব প্রোভাইডার</option>
                          {filteredProviders.map((prov) => (
                            <option key={prov._id} value={prov._id}>
                              {prov.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-1">
                        <button
                          type="submit"
                          className="btn btn-register rounded-pill px-4"
                          disabled={loading}
                        >
                          ফিল্টার
                        </button>
                      </div>
                      <div className="col-md-1">
                        <button
                          type="button"
                          className="btn btn-cancel rounded-pill px-4"
                          onClick={resetFilters}
                          disabled={loading}
                        >
                          রিসেট
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                {loading && (
                  <div className="alert alert-info">লোড হচ্ছে...</div>
                )}
                {games.length === 0 && !loading && (
                  <div className="alert alert-warning">
                    কোনো গেম পাওয়া যায়নি।
                  </div>
                )}
                {games.length > 0 && (
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover table-bordered">
                        <thead className="gradient-bg text-white">
                          <tr>
                            <th>ইমেজ</th>
                            <th>নাম</th>
                            <th>গেম UUID</th>
                            <th>ক্যাটাগরি</th>
                            <th>প্রোভাইডার</th>
                            

                            <th>অ্যাকশন</th>
                          </tr>
                        </thead>
                        <tbody>
                          {games.map((game) => (
                            <tr key={game._id} className="table-row-hover">
                              <td>
                                {game.image ? (
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/${game.image}`}
                                    alt={game.name}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  "কোনো ইমেজ নেই"
                                )}
                              </td>
                              <td>{game.name}</td>
                              <td>{game.game_uuid}</td>
                              <td>{game.category?.name || "N/A"}</td>
                              <td>{game.provider?.name || "N/A"}</td>
                              

                              <td>
                                <button
                                  className="btn btn-edit me-2"
                                  onClick={() => handleEdit(game)}
                                  disabled={loading}
                                >
                                  <FaEdit /> এডিট
                                </button>
                                <button
                                  className="btn btn-delete"
                                  onClick={() => handleDelete(game._id)}
                                  disabled={loading}
                                >
                                  <FaTrash /> মুছুন
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        className="btn btn-register rounded-pill px-4 me-2"
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1 || loading}
                      >
                        পূর্ববর্তী
                      </button>
                      <span className="align-self-center mx-3">
                        পৃষ্ঠা {page} এর মধ্যে {totalPages}
                      </span>
                      <button
                        className="btn btn-register rounded-pill px-4"
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page === totalPages || loading}
                      >
                        পরবর্তী
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamesPage;